var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9897 9.70996H7.00977C6.59977 9.70996 6.25977 9.36996 6.25977 8.95996C6.25977 8.54996 6.59977 8.20996 7.00977 8.20996H16.9897C17.3997 8.20996 17.7397 8.54996 17.7397 8.95996C17.7397 9.36996 17.3997 9.70996 16.9897 9.70996Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.71002C11.59 9.71002 11.25 9.37002 11.25 8.96002V7.28003C11.25 6.87003 11.59 6.53003 12 6.53003C12.41 6.53003 12.75 6.87003 12.75 7.28003V8.96002C12.75 9.37002 12.41 9.71002 12 9.71002Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.4699C6.59 17.4699 6.25 17.1299 6.25 16.7199C6.25 16.3099 6.59 15.9699 7 15.9699C10.72 15.9699 13.75 12.8199 13.75 8.93994C13.75 8.52994 14.09 8.18994 14.5 8.18994C14.91 8.18994 15.25 8.52994 15.25 8.93994C15.25 13.6499 11.55 17.4699 7 17.4699Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 17.47C15.0302 17.47 13.2002 16.49 11.8602 14.7C11.6102 14.37 11.6802 13.9 12.0102 13.65C12.3402 13.4 12.8102 13.47 13.0602 13.8C14.1202 15.2 15.5202 15.97 17.0102 15.97C17.4202 15.97 17.7602 16.31 17.7602 16.72C17.7602 17.13 17.4102 17.47 17.0002 17.47Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageSquare);
export default __webpack_public_path__ + "static/media/language-square.00230d6b98a6c8bf29cef365eb1f3f87.svg";
export { ForwardRef as ReactComponent };